<template>
  <v-text-field
    type="text"
    ref="input"
    :disabled="this.cityInputIsDisabledInternal"
    :name="this.data.name"
    :label="this.data.text"
    :class="this.data.name"
    :rules="this.data.rules"
    v-model="inputValue"
    v-on:change="onBlur"
    v-on:keyup="onKeyUp"
    :color="this.user.config.parameters.parameters.colorprimary"
  />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');
import Vue from 'vue';

export default Vue.extend({
  name: 'Input',
  data() {
    return {
      inputValue: this.data.value,
      cityInputIsDisabledInternal: this.cityInputIsDisabled
    };
  },
  props: {
    data: Object,
    value: String,
    cityInputIsDisabled: Boolean
  },
  computed: mapGetters(['user']),
  methods: {
    change(mode) {
      this.$store.dispatch('errors/resetErrors', this.data.name);

      if (this.data.value === '' && this.inputValue === '') {
        this.inputValue = '';
      }

      if (mode === 'keyup' && this.data.onkeyup) {
        this.emitToParent();
      } else if (mode === 'blur' && this.data.onblur) {
        this.emitToParent();
      }
    },
    onKeyUp() {
      this.change('keyup');
    },
    onBlur() {
      this.change('blur');
    },
    emitToParent() {
      this.$emit('childToParent', this.inputValue);
    }
  },
  watch: {
    value: function(newVal) {
      this.inputValue = newVal;
    },
    cityInputIsDisabled: function(newVal) {
      this.cityInputIsDisabledInternal = newVal;
    }
  }
});
</script>

<style lang="scss">
.registrationplate input {
  text-transform: uppercase;
}
</style>
